import type { Yacht } from '../../../mocks/yachtListings';

interface YachtCardProps {
  yacht: Yacht;
}

export default function YachtCard({ yacht }: YachtCardProps) {
  const formatPrice = (price: number) => {
    return `$${(price / 1000000).toFixed(1)}M`;
  };

  const displayPrice = yacht.priceDisplay || formatPrice(yacht.price);

  return (
    <div className="group cursor-pointer">
      {/* Image */}
      <div className="relative w-full h-[400px] overflow-hidden mb-6">
        <img
          src={yacht.image}
          alt={yacht.name}
          className="w-full h-full object-cover object-center group-hover:scale-105 transition-transform duration-700"
        />
        <div className="absolute top-6 right-6 bg-white/95 backdrop-blur-sm px-6 py-3">
          <p className="font-serif text-2xl text-black">{displayPrice}</p>
        </div>
      </div>

      {/* Content */}
      <div className="space-y-4">
        <div>
          <h3 className="font-serif text-3xl text-black mb-2 group-hover:text-gray-600 transition-colors">
            {yacht.name}
          </h3>
          <p className="text-lg text-gray-600">
            {yacht.year} | {yacht.builder} | {yacht.length}m
          </p>
        </div>

        <p className="text-base text-gray-700 leading-relaxed line-clamp-2">
          {yacht.description}
        </p>

        {/* Specifications */}
        <div className="grid grid-cols-2 gap-4 pt-4 border-t border-gray-200">
          <div>
            <p className="text-sm text-gray-500 mb-1">Location</p>
            <p className="text-base text-black">{yacht.location}</p>
          </div>
          <div>
            <p className="text-sm text-gray-500 mb-1">Guests</p>
            <p className="text-base text-black">{yacht.guests} guests / {yacht.crew} crew</p>
          </div>
          <div>
            <p className="text-sm text-gray-500 mb-1">Cabins</p>
            <p className="text-base text-black">{yacht.cabins} cabins</p>
          </div>
          <div>
            <p className="text-sm text-gray-500 mb-1">Speed</p>
            <p className="text-base text-black">{yacht.speed} knots</p>
          </div>
        </div>

        {/* Features */}
        <div className="flex flex-wrap gap-2 pt-4">
          {yacht.features.slice(0, 4).map((feature, index) => (
            <span
              key={index}
              className="px-3 py-1 text-sm text-gray-700 border border-gray-300"
            >
              {feature}
            </span>
          ))}
        </div>

        {/* CTA */}
        <div className="pt-4">
          <button className="w-full py-4 bg-black text-white text-base font-medium hover:bg-gray-800 transition-colors whitespace-nowrap">
            Request Information
          </button>
        </div>
      </div>
    </div>
  );
}
